import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Notifications = ({ userData, onUpdate, onFieldChange }) => {
  // Define notification fields (mapped to webNotifications in User model)
  const notifications = [
    { label: "Cases Created", field: "casesCreatedByAccount" }, // Parent field
    { label: "Cases Created, by the Account", field: "casesCreatedByAccount" },
    { label: "Cases Created, by the Lab", field: "casesCreatedByLab" },
    { label: "Cases Changed", field: "casesChangedByAccount" }, // Parent field
    { label: "Account Changed, by the Account", field: "accountChangedByAccount" },
    { label: "Account Changed, by the Lab", field: "accountChangedByLab" },
    { label: "Pickup Requests", field: "pickupRequests" },
    { label: "Balance Payments", field: "balancePayments" },
    { label: "Invoices", field: "invoices" },
    { label: "Processes", field: "processes" },
    { label: "Accounts", field: "accounts" },
    { label: "Accounts Changed, by the Lab", field: "accountsChangedByLab" },
  ];

  // Handle checkbox changes
  const handleChange = (event) => {
    const { name, checked } = event.target;
    // Map label to field for webNotifications
    const field = notifications.find((item) => item.label === name)?.field;
    if (field) {
      onFieldChange("webNotifications", field, checked);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare updated data
    const updatedData = {
      ...userData,
      webNotifications: {
        ...userData.webNotifications,
      },
    };

    // Call onUpdate to submit changes to the server
    const success = await onUpdate(updatedData);
    if (success) {
      toast.success("Notifications updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
    }
  };

  return (
    <>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          ></div>
          <div className="col-md-10">
            <h1 className="title">Web Notifications</h1>
            <form onSubmit={handleSubmit}>
              <div
                className="Web Notification"
                style={{
                  border: "1px solid #f8f9fa",
                  borderTop: "3px solid #004aad",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <h4>Labnext Activity Log</h4>
                <div className="checks" style={{ marginLeft: "20%" }}>
                  {notifications.map((item, index) => (
                    <div key={index}>
                      <label
                        style={{
                          marginLeft: index > 0 && index < 3 ? "20px" : "0px", // Indent sub-items under Cases Created
                        }}
                      >
                        <input
                          type="checkbox"
                          name={item.label}
                          checked={userData.webNotifications[item.field] || false}
                          onChange={handleChange}
                          style={{ marginRight: "10px" }}
                        />
                        {item.label}
                      </label>
                      <br />
                      <br />
                    </div>
                  ))}
                </div>
                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginRight: "20px" }}
                  >
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default Notifications;